import HeaderLogo from './HeaderLogo';
import MobileLogoLightSrc from 'assets/MobileLogoLight.png';
import MobileLogoSrc from 'assets/MobileLogo.png';
import useLogoCache from './useLogoCache';
import {useTheme} from '@mui/material';
import {Routes} from 'constants/routes';
import {Link} from 'react-router-dom';
import {useDeviceInfo} from 'utils/hooks/useDeviceInfo';

export const HeaderLogoBlock = () => {
    const theme = useTheme();
    const {isMobile} = useDeviceInfo();

    const {logoSvg: proReportLogoSvg} = useLogoCache(theme.palette.mode, 'pro-report');

    return (
        <Link to={Routes.Main}>
            {isMobile ? (
                <img src={theme.palette.mode === 'light' ? MobileLogoLightSrc : MobileLogoSrc} />
            ) : (
                <HeaderLogo
                    logoSvg={proReportLogoSvg}
                    width='210px'
                    height='43px'
                />
            )}
        </Link>
    );
};
